import React from 'react'
import {
  TextField,
} from 'react-admin'

const CustomStringField = ({ property, name, dispatch, ...props }) => {
  return <TextField {...props} source={name} />
}
export default CustomStringField
